import React from 'react'
import { EventsList } from './Data';
import { useNavigate } from 'react-router-dom';

const Workinner = () => {

    const history=useNavigate();
    const eventHandler=(register)=>{
     window.open(register)
    }
    const eventHandler1=(page)=>{
      window.scrollTo(0,0)
      history(page)
    }
   
    return (
        <>
             <div className="workshop__workshops">
                 <h1 style={{position:'relative',width:'80%',margin:'auto',textAlign:'center',color:'#fff',fontWeight:'350',textTransform:'capitalize',fontSize:'2rem',textDecoration:'2px solid underline orange'}}>workshops</h1>
               <div className="content">
                   
                   {
                       EventsList.map((item)=>{
                           return(
                            <div className="item">
                            <div className="img__content">
                               <img src={item.img} alt="" />
                               <div className="content">
                                   <h3>{item.name}</h3>
                                   <p>{item.description}</p>
                               </div>
                               </div>
                                <div className="inner">
                                    <button  onClick={()=>eventHandler(item.register)}>register</button>
                                    <button onClick={()=>eventHandler1(item.explore)}>explore</button>
                                </div>
                            </div>
                           )
                       })
                   }
                  
                   

               </div>
            </div>
        </>
    )
}

export default Workinner
